import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="translate"
export default class extends Controller {
  static targets = ["fieldToTranslate"]
  static values = {
    sourceLanguage: {type: String, default: "NL"},
    targetLanguage: {type: String, default: "EN"}
  }

  connect() {
    console.log("translate controller connected")

    if (this.sourceLanguageValue.toUpperCase() == this.targetLanguageValue.toUpperCase()) {
      return
    }

    this.createTranslateButton();
  }

  createTranslateButton() {
    const button = document.createElement("button")
    button.classList.add("btn", "btn-outline-primary", "btn-sm", "m-btn", "m-btn--icon", "m-btn--outline-2x")
    const icon = document.createElement("i")
    icon.classList.add("la", "la-language")
    icon.style.fontSize = "20px"
    
    const text = document.createElement("span")
    text.textContent = `translate: ${this.sourceLanguageValue} to ${this.targetLanguageValue}`
    text.style.display = "inline"
    text.style.marginLeft = "5px"
    
    button.appendChild(icon)
    button.appendChild(text)
    
    
    button.style.display = "block"
    button.style.marginBottom = "10px"
    button.style.width = "fit-content"
    
    button.addEventListener("click", this.translate.bind(this))
    
    const fieldContainer = $(this.fieldToTranslateTarget).parent()
    const label = fieldContainer.find('label').first()
    
    if (label.length > 0) {
      // Insert button after the label
      label.after(button)
    } else {
      // Fallback: prepend to container if no label found
      fieldContainer.prepend(button)
    }
  }

  translate(e) {
    e.preventDefault();
    e.stopPropagation();
    let fieldFromClass = this.fieldToTranslateTarget.classList[0].replace(`-${this.targetLanguageValue}`, `-${this.sourceLanguageValue}`)
    let fieldToTranslateFrom = $(`.${fieldFromClass}`)
    let sourceText = fieldToTranslateFrom.val()
    
    let url = "/api/translations/translate"
    fetch(url, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({
        source_language: this.sourceLanguageValue,
        target_language: this.targetLanguageValue,
        source_text: sourceText
      })
    }).then(response => response.json()).then(data => {
      $(this.fieldToTranslateTarget).val(data.translated_text);
      if ($(this.fieldToTranslateTarget).hasClass(`summernote`)) {
        $(this.fieldToTranslateTarget).summernote('reset')
        $(this.fieldToTranslateTarget).summernote('code', data.translated_text)
      }
    })
  }
}
